<template >
    <div class="container">
        <div class="card o-hidden border-1">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->

                <div class="p-5">
                  <div class="row text-center">
                    <div class="col col-expand">
                      <h1 class="h4 text-gray-900 mb-4">Хичээл нэмэх</h1>
                    </div>
                    <div class="col-auto">
                        <i class="fas fa-grip-horizontal text-danger" style="font-size:20px; cursor:pointer" title="Дэлгэрэнгүй болгож xараx" v-if="!advanced" @click="advanced=!advanced"></i>
                        <i class="fas fa-grip-lines text-danger" style="font-size:20px; cursor:pointer" title="Xураангуйлан xараx" v-else @click="advanced=!advanced"></i>
                    </div>
                  </div>
                  <form class="user">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Хичээл:</label>
                      <select class="form-control" v-model='lesson.category'>
                        <option v-for="(type, index) in categories" v-bind:key="'type-'+type.id" v-bind:value="type.ref">{{index+1}}. {{type.name}} <span v-if="type.typeDetail">- {{type.typeDetail.name}}</span></option>
                      </select>
                    </div>
                    <!-- <div class="form-group">
                      <label>Хичээлийн нэр</label>
                      <input v-model.trim="lesson.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Хичээлийн нэр">
                    </div> -->


                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Aнги/группээр орох:</label>
                      <div class="form-check">
                        <input v-model="lesson.isGroup" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-bind:value="false">
                        <label class="form-check-label" for="exampleRadios1">
                          Ангиар ороx
                        </label>
                      </div>
                      <div class="form-check">
                        <input v-model="lesson.isGroup" class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-bind:value="true">
                        <label class="form-check-label" for="exampleRadios2">
                          Группээр ороx
                        </label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col form-group">
                        <label for="exampleFormControlSelect1">Секц:</label>
                        <select class="form-control" v-model='lesson.sector'>
                          <option v-for="type in sectors" v-bind:key="'sector-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                      
                    </div>
                    <div class="row" v-if="advanced==true">
                      <div class="col-md-6 col-sm-12 form-group">
                       <label>Зорилго</label>
                        <div class="row">
                          <div class="col col-10">
                            <textarea v-on:keyup.enter="addResult" v-model.trim="result" type="text" class="form-control" placeholder="Зорилго"/>
                          </div>
                          
                          <div class="col col-2 ">
                            <div @click="addResult" class="btn btn-success btn-block">
                              нэмэх
                            </div>
                          </div>
                        </div>
                        <ul  v-if="lesson.results!=null && lesson.results.length>0">
                          <li  v-for="(include,index) in lesson.results" v-bind:key="include">{{include}}
                            <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.results)"></i>
                          </li>
                        </ul>
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Эзэмшүүлэх мэдлэг</label>
                        <div class="row">
                          <div class="col col-10">
                            <textarea v-on:keyup.enter="addLearned" v-model.trim="whatlearned" type="text" class="form-control" placeholder="Эзэмшүүлэх мэдлэг"/>
                          </div>
                          <div class="col col-2 ">
                            <div @click="addLearned" class="btn btn-success btn-block">
                              нэмэх
                            </div>
                          </div>
                        </div>
                        <ul v-if="lesson.whatlearned!=null && lesson.whatlearned.length>0">
                          <li v-for="(include, index) in lesson.whatlearned" v-bind:key="include">{{include}}
                            <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.whatlearned)"></i>
                          </li>
                        </ul>
                      </div>

                    </div>
                    <div class="row" v-if="advanced && advanced==true">

                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Xүний ур чадвар, хандлага</label>
                        <div class="row">
                          <div class="col col-10">
                            <textarea v-on:keyup.enter="addHandlaga"  v-model.trim="handlagaText" type="text" class="form-control" placeholder="Хичээлээр эзэмшүүлэх хувь хүний ур чадвар, хандлага"/>
                          </div>
                          
                          <div class="col col-2 ">
                            <div @click="addHandlaga" class="btn btn-success btn-block">
                            нэмэх
                            </div>
                          </div>
                        </div>
                        <ul  v-if="lesson.handlaga!=null && lesson.handlaga.length>0">
                          <li  v-for="(include, index) in lesson.handlaga" v-bind:key="include">{{include}}
                            <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.handlaga)"></i>
                          </li>
                        </ul>
                      </div>

                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Шаардлага</label>
                        <div class="row">
                          <div class="col col-10">
                            <textarea v-on:keyup.enter="addRequirement" v-model.trim="requirement" type="text" class="form-control" placeholder="Хичээлийн шаардлага (Зөөврийн компьтертэй байх зэрэг шаардлага)"/>
                          </div>
                          
                          <div class="col col-2 ">
                            <div @click="addRequirement" class="btn btn-success btn-block">
                            нэмэх
                            </div>
                          </div>
                        </div>
                        <ul  v-if="lesson.requirements!=null && lesson.requirements.length>0">
                          <li  v-for="(include, index) in lesson.requirements" v-bind:key="include">{{include}}
                            <i class="fas fa-trash text-danger text-small" style="cursor:pointer" @click="remove(index, lesson.requirements)"></i>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <hr/>
                    
                   
                  </form>
                  <div>
                    <div class="row">
                      <div class="col col-expand">
                        <h5 class="h5 font-weight-bold">Хичээл заах багш нар болон анги/группууд/</h5>
                      </div>
                      <div class="col col-auto" >
                        <div v-if="lesson.isGroup!=null && lesson.isGroup!=undefined" >
                          <button type="button" class="btn btn-danger btn-sm mr-2" @click="_addTopic">
                            Анги нэмэх
                          </button>
                          <button  v-if="lesson.isGroup==true" type="button" class="btn btn-info btn-sm mr-2" @click="_addGroup">
                            Групп нэмэх
                          </button>
                        </div>
                        <span v-else class="text-danger font-weight-bold">Та уг хичээл ангиар орох эсвэл группээр орох эсэхийг сонгоно уу</span>

                      </div>
                    </div>
                    <div class="mt-2">
                      <table class="table table-sm table-bordered">
                        <tr v-for="item in groupList">
                          <td>
                            <span v-if="item.teacher">{{item.teacher.name}} - {{item.teacher.code}} - {{item.teacher.email}}</span>
                          </td>
                          <td>
                            <ul v-if="item.isGroup && item.isGroup==true">
                              <li v-for="program in item.programs">
                                {{program.data().name}}
                              </li>
                            </ul>
                            <ul v-else>
                              <li v-for="(program,index) in item.programs">
                                <span class="text-uppercase text-primary">{{item.department.name}}{{program.name}}</span>
                                <span v-if="index<item.programs.length-1">, </span>
                              </li>
                            </ul>
                          </td>
                          <td>
                            <span class="badge badge-info" v-if="item.isGroup && item.isGroup==true">
                              групп
                            </span>
                            <span class="badge badge-success" v-else>
                              анги
                            </span>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <hr/>
                  <div class="row">
                    <div class="text-center col">
                      <a class="small" href="#" @click="$router.back()">Буцах</a>
                    </div>
                    <div class="col">
                      <div @click="save" class="btn btn-primary">
                        Хадгалах
                      </div>
                    </div>
                  </div>
                  <hr>
                
                </div>


          </div>
        </div>

    <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Багш анги нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">

                  <div class="col" v-if="teachers && teachers.length>0">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Хичээл заах багш:</label>
                      <select class="form-control" v-model="selectedTeacher" >
                        <option v-for="(teacher, index) in teachers" v-bind:value="teacher">{{teacher.name}} - {{teacher.code}} - {{teacher.email}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">

                  <div class="col" v-if="departments && departments.length>0">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Анги:</label>
                      <select class="form-control" v-model="department" >
                        <option v-for="(dep, index) in departments" v-bind:key="dep.id" v-bind:value="dep">{{dep.name}}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="department!=null">
                  <!-- <label for="exampleFormControlSelect1">Бүлэг:</label> -->

                  <div class="d-flex flex-row my-3  justify-content-center">
                    <div @click="toggleDepartmentFilter(pro, selectedPrograms)" 
                      style="cursor:pointer;font-size:26px;" 
                      class="badge px-3 py-2 mr-2"
                      v-for="pro in programs" 
                      v-bind:class="[isInDepartmentFilter(pro, selectedPrograms)==true ? 'badge-success text-black' : 'text-primary bg-light ']">
                      {{pro.name}}
                    </div>
                  </div>
                  <!-- <select class="form-control" v-model="program" >
                    <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{pro.data().name}}</option>
                  </select> -->
                </div>
                
          
         
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="_addProgram" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Нэмэх</button>
            </div>
          </div>
        </div>
      </div>

    <!-- Modal -->
      <div class="modal fade" id="groupModal" tabindex="-1" role="dialog" aria-labelledby="groupModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="groupModalLabel">Групп нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">

                  <div class="col" v-if="teachers && teachers.length>0">
                    <div class="form-group">
                      <label for="exampleFormControlSelect1">Хичээл заах багш:</label>
                      <select class="form-control" v-model="selectedTeacher" >
                        <option v-for="(teacher, index) in teachers" v-bind:value="teacher">{{teacher.name}} - {{teacher.code}} - {{teacher.email}}</option>
                      </select>
                    </div>
                  </div>
                </div>
          
                <div class="form-group" v-if="lessonGroups">
                  <div class="row my-3  justify-content-center">
                    <div @click="toggleDepartmentFilter(pro, selectedGroups)" 
                      style="cursor:pointer;font-size:14px;" 
                      class="badge px-3 py-2 mr-2 my-2" 
                      v-for="pro in lessonGroups" 
                      v-bind:class="[isInDepartmentFilter(pro, selectedGroups)==true ? 'badge-success text-black' : 'text-primary bg-light ']">
                      {{pro.data().name}}
                    </div>
                  </div>
                  <!-- <select class="form-control" v-model="program" >
                    <option v-for="(pro, index) in department.programs" v-bind:key="pro.id" v-bind:value="pro">{{pro.data().name}}</option>
                  </select> -->
                </div>
          
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button @click="_addObjectToGroup" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Save</button>
            </div>
          </div>
        </div>
      </div>


    <div v-if="loading==true" style="position:fixed;z-index:10000000; top:45%;left:45%">
        <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-secondary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-success" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-danger" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-warning" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-info" role="status">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="spinner-grow text-dark" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>

  </div>
</template>

<script>
const fb = require('../../../firebaseConfig.js');
import { mapState } from 'vuex';
import { copyFile } from 'fs';
export default {
    name: "ILessonAddGroup",
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    data() {
        return {
            lesson: {
                name: '',
                description: '',
                requirements:[],
                results:[],
                whatlearned:[],
                teacherFirstName:'',
                teacherLastName:'',
                // skills:[],
                handlaga:[],
                semester:null, 
                credit:null,
                type:null,
                category:null,
                isGroup:null,
                sector:null
               
            },
            performingRequest:false,
            requirement:'',
            result:'',
            whatlearned:'',
            // skill:'',
            handlagaText:'',
            schools:[],
            school:null,
            department:null,
            programs:[],
            program:null,
            semesters:[],
            semester:null,
            departments:[],
            paymentTypes:[],
            categories:[],
            teachers:[],
            selectedTeacher:null,
            sectors:[],
            selectedPrograms:[],
            selectedGroups:[],
            groupList:[],
            loading:false,
            advanced:false,
            lessonGroups:[]
 
        };
    },
    watch:{

      department: function (val) {
          if(val && val.ref){
              this.programs=[];
              this.selectedPrograms=[];
              this._getPros(val);
          }
      },
      'lesson.isGroup':function(val){
        this.groupList=[];
      },
      'lesson.category':function(val){

        if(val && val.id){
          val.get().then(doc=>{
            if(doc && doc.exists && doc.data() && doc.data().name){
              this.lesson.name=doc.data().name;
            }
          });
        }
      },
      'lesson.sector':function(val){
        this.teachers=[];
        if(val && val.id){
          fb.db.collection("schools/"+this.schoolId+"/teachers").where("sector","==", val).orderBy("name").get().then(querySnapshot=>{
            querySnapshot.forEach(paymentData=> {
              let object=paymentData.data();
              object.ref=paymentData.ref;
              object.id=paymentData.id;
              this.teachers.push(object);
            });
          });
        }
        else{
          fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name").get().then(querySnapshot=>{
            querySnapshot.forEach(paymentData=> {
              let object=paymentData.data();
              object.ref=paymentData.ref;
              object.id=paymentData.id;
              this.teachers.push(object);
            });
          });
        }
      },
      selectedTeacher:function(val){
        if(val && val.id && val.ref){
          this.lessonGroups=[];
          fb.db.collection("schools/"+this.schoolId+"/lessonGroups").where("teacher", "==", val.ref)
            .get()
            .then(querySnapshot=> {
              let deps=[];
              querySnapshot.forEach(depdata=> {
                deps.push(depdata);
              });
              this.lessonGroups=deps; 
          });
        }
        else{
          fb.db.collection("schools/"+this.schoolId+"/lessonGroups").orderBy("createdAt")
            .get()
            .then(querySnapshot=> {
              let deps=[];
              querySnapshot.forEach(depdata=> {
                deps.push(depdata);
              });
              this.lessonGroups=deps; 
            });
        }
      }
    },
    methods: {
        async save() {
         
            this.performingRequest = true;
            if(this.lesson!=null && this.lesson.name!='' && this.lesson.category && this.lesson.isGroup!=null && this.lesson.isGroup!=undefined && this.groupList && this.groupList.length>0){
              this.loading=true;
              this.lesson.name=this.capitalizeFirstLetter(this.lesson.name);
              this.lesson.userId=this.$store.getters.currentUser.uid;
              this.lesson.user=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
              this.lesson.createdAt=new Date();
              this.lesson.checkedAt=new Date();
              this.lesson.lectureCode=new Date().getTime();
              this.lesson.school=null;

              var categoryDoc=await this.lesson.category.get();

              
              for(const group of this.groupList){
                if(group && group.teacher){
                  var batch=fb.db.batch();
                  var lessonRef=fb.db.collection("schools").doc(this.schoolId).collection("lessons").doc();
                  var copiedLesson=Object.assign({}, this.lesson);

                  copiedLesson.teacher=group.teacher.ref;
                  var teacherDoc=await group.teacher.ref.get();
                  copiedLesson.teachers=[];
                  copiedLesson.teacherRefs=[];
                  copiedLesson.school=fb.db.collection("schools").doc(this.schoolId);
                  copiedLesson.teachers.push({
                    "firstName": teacherDoc.data().firstName!=undefined && teacherDoc.data().firstName!=null?teacherDoc.data().firstName:teacherDoc.data().name,
                    "lastName": teacherDoc.data().lastName!=undefined && teacherDoc.data().lastName!=null?teacherDoc.data().firstName:teacherDoc.data().lastname,
                    "description": teacherDoc.data().description!=undefined && teacherDoc.data().description!=null?teacherDoc.data().description:'Багш',
                    "reference": teacherDoc.ref
                  });

                  copiedLesson.teacherRefs.push(teacherDoc.ref);

                  if(teacherDoc.data().firstName){
                    copiedLesson.teacherFirstName=teacherDoc.data().firstName;
                  }
                  if(teacherDoc.data().lastName){
                    copiedLesson.teacherLastName=teacherDoc.data().lastName;
                  }
                  batch.set(
                    lessonRef,
                    copiedLesson
                  );
                  
                  if(group.programs && group.programs.length>0){
                    if(group.isGroup && group.isGroup==true){
                      copiedLesson.lessonGroups=[];
                      copiedLesson.lessonGroupRefs=[];
                      copiedLesson.lessonGroupIds=[];
                      for(const groupData of group.programs){
                        copiedLesson.lessonGroups.push( {
                          school:fb.db.collection("schools").doc(this.schoolId),
                          group: groupData.ref,
                          groupName: groupData.data().name
                        });

                        copiedLesson.lessonGroupRefs.push(groupData.ref);
                        copiedLesson.lessonGroupIds.push(groupData.id);
                        this.addClassToGroup(groupData,batch, lessonRef);

                      }
 
                    }
                    else{
                      copiedLesson.groups=[];
                      copiedLesson.programs= [];
                      copiedLesson.programIds= [];
                      copiedLesson.departments= [];
                      copiedLesson.classNos= [];

                      copiedLesson.lessonGroups=[];
                      copiedLesson.lessonGroupRefs=[];
                      copiedLesson.lessonGroupIds=[];
                      
                      copiedLesson.departments.push(group.department.ref);
                      copiedLesson.classNos.push(group.department.index? group.department.index:0);
                      console.log(categoryDoc.data());
                      if(categoryDoc && categoryDoc.data() && categoryDoc.data().type && categoryDoc.data().type.id=='songoh'){
                        console.log("HELLO");
                        var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
                        var tmpGroup={};
                        this.lesson.isGroup=true;
                        // tmpGroup.program=programData;
                        tmpGroup.createdAt=new Date();
                        tmpGroup.name=this.lesson.name+" - "+teacherDoc.data().name+" / Сонгох -"+(group.department.name)+" анги/";
                        if(teacherDoc)
                          tmpGroup.teacher=teacherDoc.ref;
                        if(lessonRef)
                          tmpGroup.lesson=lessonRef;
                        batch.set(
                          lessonGroupRef,
                          tmpGroup
                        );
                        if(this.lesson.isGroup && this.lesson.isGroup==true){

                            copiedLesson.lessonGroups.push( {
                              school:fb.db.collection("schools").doc(this.schoolId),
                              group: lessonGroupRef,
                              groupName: tmpGroup.name
                            });

                            copiedLesson.lessonGroupRefs.push(lessonGroupRef);
                            copiedLesson.lessonGroupIds.push(lessonGroupRef.id);
                        }
                        for(const programData of group.programs){
                          copiedLesson.groups.push({
                            school: fb.db.collection("schools").doc(this.schoolId),
                            department: group.department.ref,
                            program: programData.ref,
                            departmentName: group.department.name,
                            programName: programData.name
                          });
                          copiedLesson.programs.push(programData.ref);
                          copiedLesson.programIds.push(programData.id);

                        }
                      }
                      else{
                        for(const programData of group.programs){
                          copiedLesson.groups.push({
                            school: fb.db.collection("schools").doc(this.schoolId),
                            department: group.department.ref,
                            program: programData.ref,
                            departmentName: group.department.name,
                            programName: programData.name
                          });
                          copiedLesson.programs.push(programData.ref);
                          copiedLesson.programIds.push(programData.id);

                          if(this.lesson.isGroup && this.lesson.isGroup==true){
                            var tmpGroup={};
                            tmpGroup.program=programData;
                            tmpGroup.createdAt=new Date();
                            tmpGroup.name=this.lesson.name+" - "+teacherDoc.data().name+" /"+(group.department.name+"-"+programData.name)+"/";
                            if(teacherDoc)
                              tmpGroup.teacher=teacherDoc.ref;
                            if(lessonRef)
                              tmpGroup.lesson=lessonRef;
                            var lessonGroupRef=fb.db.collection("schools").doc(this.schoolId).collection("lessonGroups").doc();
 
                            batch.set(
                              lessonGroupRef,
                              tmpGroup
                            );

                            copiedLesson.lessonGroups.push( {
                              school:fb.db.collection("schools").doc(this.schoolId),
                              group: lessonGroupRef,
                              groupName: tmpGroup.name
                            });

                            copiedLesson.lessonGroupRefs.push(lessonGroupRef);
                            copiedLesson.lessonGroupIds.push(lessonGroupRef.id);
                          }

                        }
                      }

                      copiedLesson.departments = Array.from(new Set(copiedLesson.departments));
                      copiedLesson.classNos = Array.from(new Set(copiedLesson.classNos));


                    }
                    batch.update(
                      lessonRef,
                      copiedLesson
                    );
                  }
                    
                  await batch.commit();
                  }
                }
                this.loading=false;
              
  
              // await fb.db.collection("schools").doc(this.schoolId).collection("lessons").doc().set(this.lesson);
              // if(this.$store.getters.userProfile!=null && this.$store.getters.userProfile.customer!=null){
              //   this.lesson.teacher=this.$store.getters.userProfile.customer;
              //   this.lesson.teacher.update({'numberOfLessons':fb.firestore.FieldValue.increment(1)});
              // }
              // if(this.schoolId){
              //   this.lesson.school=fb.db.collection("schools").doc(this.schoolId);
              //   // fb.db.collection("schools").doc(this.schoolId).update({
              //   //   'numberOfLessons': fb.firestore.FieldValue.increment(1)
              //   // });
              // }

              this.$router.back();
            }
            else{
              alert("Та хичээлийнхээ нэр, анги/группээр орох , ангилал болон багш ангиудаа оруулна уу");
            }
        },
        addClassToGroup(group, batch, lessonRef){


                if(group && group.data() && group.data().groups){
                  for(const data of group.data().groups){

                    batch.update(
                      lessonRef,
                      {
                        groups:fb.firestore.FieldValue.arrayUnion(data)
                      }
                    );
                  }
                  
                }
                if(group && group.data() && group.data().programs){
                  for(const data of group.data().programs){
                    batch.update(
                      lessonRef,
                      {
                        programs:fb.firestore.FieldValue.arrayUnion(data)
                      }
                    );
                  }
                  
                }
                if(group && group.data() && group.data().programIds){
                  for(const data of group.data().programIds){
                    batch.update(
                      lessonRef,
                      {
                        programIds:fb.firestore.FieldValue.arrayUnion(data)
                      }
                    );
                  }
                  
                }
                if(group && group.data() && group.data().departments){
                  for(const data of group.data().departments){
                    batch.update(
                      lessonRef,
                      {
                        departments:fb.firestore.FieldValue.arrayUnion(data)
                      }
                    );
                  }
                  
                }
                if(group && group.data() && group.data().classNos){
                  for(const data of group.data().classNos){
                    batch.update(
                      lessonRef,
                      {
                        classNos:fb.firestore.FieldValue.arrayUnion(data)
                      }
                    );
                  }
                  
                }
        },
   
        setLesson(){
          this.lesson={
                name: '',
                description: '',
                included:[],
                lectureCode:'',
                profession:"",
                requirements:[],
                results:[],
                whatlearned:[],
                skills:[],
                handlaga:[],
                semester:null,
                credit:null,
                types:[],
                price:0,

            }
        },
        addIncluded(){
          if(this.included!=null && this.included!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.included.push(this.included)
            this.included=''
          }
        },
        addRequirement(){
          if(this.requirement!=null && this.requirement!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.requirements.push(this.requirement)
            this.requirement=''
          }
        },
        addResult(){
          if(this.result!=null && this.result!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.results.push(this.result)
            this.result=''
          }
        },
        addLearned(){
          if(this.whatlearned!=null && this.whatlearned!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.whatlearned.push(this.whatlearned)
            this.whatlearned=''
          }
        },
        addSkill(){
          if(this.skill!=null && this.skill!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.skills.push(this.skill)
            this.skill=''
          }
        },
        addHandlaga(){
          if(this.handlagaText!=null && this.handlagaText!=''){
            if(this.lesson==null || this.lesson==undefined)
              this.setLesson()
            this.lesson.handlaga.push(this.handlagaText)
            this.handlagaText=''
          }
        },
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },

        addType(type){
          if(this.lesson.types==null || this.lesson.types==undefined)
            this.lesson.types=[];
          if(!this.lesson.types.includes(type))
            this.lesson.types.push(type);
          else
            this.lesson.types.splice(this.lesson.types.indexOf(type), 1); 
        },
   
        capitalizeFirstLetter(str){
          return  str.charAt(0).toUpperCase() + str.slice(1);
        },
        _getCategories(){
          fb.db.collection("schools/"+this.schoolId+ "/categories").orderBy("index")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                if(this.categoryId && this.categoryId!='' && this.categoryId!='new' && this.categoryId==object.id){
                  this.lesson.category=paymentData.ref;
                }
                this.categories.push(object);
              });
         
          });

          fb.db.collection("schools/"+this.schoolId+ "/sectors").orderBy("name")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.sectors.push(object);
              });
         
          });

          fb.db.collection("schools/"+this.schoolId+ "/departments").orderBy("index")
          .get().then(querySnapshot=> {
              querySnapshot.forEach(paymentData=> {
                let object=paymentData.data();
                object.ref=paymentData.ref;
                object.id=paymentData.id;
                this.departments.push(object);
              });
         
          });


          fb.db.collection("schools/"+this.schoolId+"/teachers").orderBy("name").get().then(querySnapshot=>{
            querySnapshot.forEach(paymentData=> {
              let object=paymentData.data();
              object.ref=paymentData.ref;
              object.id=paymentData.id;
              this.teachers.push(object);
            });
          });
          

          fb.db.collection("schools/"+this.schoolId+"/lessonGroups").orderBy("createdAt")
            .get()
            .then(querySnapshot=> {
              let deps=[];
              querySnapshot.forEach(depdata=> {
                deps.push(depdata);
              });
              this.lessonGroups=deps; 
            });
        },
        _getPros(school){
          if(school && school.ref){
            school.ref.collection("programs").orderBy("name").get().then(docs=>{
              this.programs=[];
              docs.docs.forEach(doc=>{
                  let object=doc.data();
                  object.id=doc.id;
                  object.ref=doc.ref;
                  this.programs.push(object);
              });
            });
          }
        },
        _addTopic(){
          // this.school=null;
          this.selectedTeacher=null;
          this.department=null;
          this.selectedPrograms=[];
          $('#exampleModal').modal('toggle');
        },
        _addGroup(){
          this.selectedTeacher=null;
          this.department=null
          this.selectedPrograms=[];
          this.selectedGroups=[];
          $('#groupModal').modal('toggle');
        },
        toggleDepartmentFilter(department, list){
            if(this.isInDepartmentFilter(department, list)==true){

                this.removeFromDepartmentFilter(department, list);
            }
            else{
              list.push(department);
            }
        },
        isInDepartmentFilter(department, list){
            var exists=false;
            for(const current of list){

              if(current && current.id && current.id==department.id){
                  exists=true;
                  break;
              }
            }
            return exists;
        },
        removeFromDepartmentFilter(department, list){
          var exists=false;
          var index=0;
          var i=0;
          for(const current of list){
            if(current && current.id && current.id==department.id){
                exists=true;
                index=i;
                break;
            }
            i++;
          }
          if(exists && exists==true){
            list.splice(index, 1);
          }
        },
        _addProgram(){
          if(this.selectedTeacher && this.department && this.selectedPrograms && this.selectedPrograms.length>0){

            var object={
              teacher: this.selectedTeacher,
              department: this.department,
              programs: this.selectedPrograms,
              isGroup:false
            }
            this.groupList.push(object);
            
          }
          else{
            alert("Та хичээл заах багш болон ангиудын мэдээллээ бүрэн оруулна уу.");
          }
        },
        _addObjectToGroup(){
          if(this.selectedTeacher &&  this.selectedGroups){

            var object={
              teacher: this.selectedTeacher,
              programs: this.selectedGroups?this.selectedGroups:[],
              isGroup:true
            }
            this.groupList.push(object);
            
          }
          else{
            alert("Та хичээл заах багш болон ангиудын мэдээллээ бүрэн оруулна уу.");
          }
        },

    }, 
   
    created() {
      if(this.schoolId)
        this._getCategories();
            
    },
    props: {
      schoolId: { 
        required: true,
      },
      setTeacher:{
        required:false
      },
      categoryId:{
        required:false
      }
    }
  
};
</script>

